import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import { Modal, Button } from 'antd';
import fetch from 'cross-fetch';
import * as actions from '../../actions/';

const ESB_API = process.env.REACT_APP_ESB_API;

class Session extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.verifySession = this.verifySession.bind(this);
        this.extendSession = this.extendSession.bind(this);
        this.state = {
            TimeOutloading: false,
            TimeOutvisible: false
        };
    }

    handleClick = (event) => {
        if (event.key == 3) {
            this.props.actions.logout();
        }
    }

    extendSession = () => {
        this.setState({
            TimeOutloading: true,
        })
        if (localStorage.getItem('user')) {
            const loggedinUser = JSON.parse(localStorage.getItem('user'))
            let personGUID = loggedinUser.personGuid;
            let token = loggedinUser.token;
            fetch(ESB_API + '/persons/' + personGUID + `/eagleInformation`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json; version = 1',
                    "Authorization": "Bearer " + token
                }
            })
                .then(response => {
                    if (!response.ok) {
                        return false;
                    }
                    return response.json();
                })
                .then(status => {
                    this.setState({
                        TimeOutvisible: false
                    })
                })
                .catch(err => {
                    console.error(err);
                });
        }
    }

    verifySession = () => {
        if (!localStorage.getItem('user')) {
            // Already logged out - nothing to verify, and calling logout() again
            // here would just re-fire this cycle for no reason.
            return;
        }
        let currentDateTime = new Date()
        let LastActivity = new Date(localStorage.getItem('LastActivity'))
        let diff = (Date.parse(LastActivity) - Date.parse(currentDateTime)) / 1000;
        diff /= 60;
        let DifferentMintues = Math.abs(Math.round(diff))
        //Logout
        if (DifferentMintues > process.env.REACT_APP_LOGOUT_SESSION_ON) {
            this.props.actions.logout()
        }
        //Show Session Extend Modal
        else if (DifferentMintues >= process.env.REACT_APP_SHOW_EXTEND_SESSION_MODAL_ON) {
            this.setState({
                TimeOutvisible: true,
                TimeOutloading: false,
            })
        }
        //Extend Session API
        //else if (DifferentMintues >= process.env.REACT_APP_EXTEND_SESSION_ON) {
          // this.extendSession()
        //}
    }

    componentDidMount = (e) => {
        localStorage.setItem('LastActivity', new Date())
        window.onclick = function () {
            this.localStorage.setItem('LastActivity', new Date())
        };
        this.sessionCheckInterval = setInterval(() => this.verifySession(), 60000)
    }

    componentWillUnmount = () => {
        // Session is remounted on every protected page (it lives inside Header,
        // which every page renders separately) - without clearing this, every
        // navigation leaked another interval that kept calling logout() forever.
        clearInterval(this.sessionCheckInterval)
    }

    render() {
        const { TimeOutloading, TimeOutvisible } = this.state;
        return (
            <div>

                <Modal
                    centered
                    title="Session Timeout"
                    className="TimeOutModal"
                    visible={TimeOutvisible}
                    wrapClassName="vertical-center-modal"
                    loading={TimeOutloading}
                    width="auto"
                    footer={[
                        <Button key="submit" type="primary" loading={TimeOutloading} onClick={this.extendSession}>
                            Continue
                        </Button>
                    ]}
                >
                    <p>
                        Your session is about to expire.
                    </p>
                    <p>
                        Click continue to keep your session active.
                    </p>
                </Modal>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) }
}

export default connect(null, mapDispatchToProps)(Session);


// WEBPACK FOOTER //
// ./src/components/HOC/Session.js